export default __webpack_public_path__ + "svgs/focusOnline-54d3f08b.svg";